import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { _longPressTypes, LongPressWrapper } from 'global/wrappers/LongPressWrapper'
import _ from 'lodash'
import React, { useContext, useMemo } from 'react'
import { Divider, Image } from 'semantic-ui-react'
import { uniqueKey } from '../../common/keys'
import { gEnums } from '../../enums/globalEnums'
import { iconColorTypes } from '../../enums/settingsIconTypes'
import SemPdfSimple from '../sem/SemPdfSimple'
import { FileManagementContext } from 'global/cnr/contexts/FileManagementContext'
/**
 * 
 * @param {object} props 
 * @returns a GRID of images only
 */
const ImagesGrid = (props) => {

  const { igProps, viewOnly } = props ?? {}

  const {
    approvedOnly,
    documentKey,
    galleryItem,
    handlers,
    imageOwner,
    isFullGalleryItem,
    isProfile,
    isPdf,
    selectedImages,
    showApprovalWizard,
    storageType,
    storageLocationType,
    handlePdfIconClick,
  } = igProps ?? {}

  const {
    handleImageClick,
    handleImageSelect,
    handleImageEdit,
    handlePdfClick
  } = handlers

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { storage_state } = states
  const { fileOptionType, storageType: storage_type, viewItemType, viewItemItem, appStorageUrlFiles } = storage_state

  const fileManagementContext = useContext(FileManagementContext);
  const { fileManagement_state } = fileManagementContext ?? {}
  const { fileManagmentOpts } = fileManagement_state ?? {}
  const { storageType: _storageType } = fileManagmentOpts ?? {}
  // const { viewItemItem } = fileManagmentOpts ?? {} 

  let _storage_type = storageType || _storageType || storage_type || gEnums.storageTypes.image
  let _fileOptionType = fileOptionType || gEnums.fileOptionTypes.global

  const currentGallery = useMemo(() => {

    const { global, pages } = appStorageUrlFiles ?? {}

    switch (_fileOptionType) {
      case gEnums.fileOptionTypes.global:
        let asst = _storage_type
        switch (_storage_type) {
          case gEnums.storageTypes.manifest:
            asst = 'manifests'
            return global?.[asst]
          default:
            // nothings 
            const xxx = global?.[asst]
            const _xxx = []
            if (xxx) {
              _.forEach(xxx, (xxxx, xKey) => {
                _xxx.push({ urls: xxxx, itemKey: xKey })
              })
            }
            return _xxx
        }
      case gEnums.fileOptionTypes.pages:
        const assettUrls = pages?.[viewItemType]?.[viewItemItem?._itemKey];
        const _assettUrls = []
        _assettUrls.push({ urls: assettUrls, itemKey: viewItemItem?._itemKey })
        return _assettUrls
    }

  }, [_fileOptionType, storage_type, appStorageUrlFiles, viewItemType, viewItemItem])

  const handleClick_image = (e, imageProps) => {
    const _imageProps = {
      viewItemType,
      viewItemType,
      ...imageProps
    }
    if (_imageProps?.imageKey) {
      handleImageSelect(e, _imageProps)
    } else {
      handleImageClick(e, _imageProps)
    }
  }

  const _isPdf = _storage_type === gEnums.storageTypes.pdf

  let _cn = 'grid-storage-images'
  if (documentKey) { _cn += ' ' + documentKey }
  if (_storage_type) { _cn += ' ' + _storage_type }

  const thumbnailImage = (src, key, divCn, imageCn, customMetadata) => {
    if (_isPdf) {
      return <div className={divCn}>
        {src ? pdfColumns(src, key, imageCn, customMetadata) : <div className={imageCn}>Pending</div>}
      </div>
    } else {
      return <div className={divCn}>
        {src ? <Image className={imageCn} src={src} /> : <div className={imageCn}>Pending</div>}
      </div>
    }
  }

  const thumbnailDivImage = (src, key, approved, customMetadata, imageProps) => {
    const { itemKey } = imageProps ?? {}
    const imageCn = 'img-ts-image'
    let divCn = 'img-ts-container ig'
    divCn += !approved ? ' pending' : ''
    if (selectedImages?.[itemKey]) {
      divCn += ' selx'
    }

    const handleSelectImage = () => {
      handleImageEdit(null, imageProps)
    }

    const handleClick = () => {
      handleClick_image(null, imageProps)
    }

    switch (_storage_type) {
      case gEnums.storageTypes.image:
        return <LongPressWrapper
          longPressType={_longPressTypes.image_grid}
          itemData={imageProps}
          onClick={handleClick}
        >
          {thumbnailImage(src, key, divCn, imageCn, customMetadata)}
        </LongPressWrapper>
      default:
        return <LongPressWrapper
          // longPressType={_longPressTypes.image_grid}
          itemData={imageProps}
          onClick={handleClick}
        >
          {thumbnailImage(src, key, divCn, imageCn, customMetadata)}
        </LongPressWrapper>
      // return thumbnailImage(src, key, divCn, imageCn, customMetadata)
    }
  }

  const imageColumn = (src, key, cn, icn, approved, path, customMetadata, item) => {
    const imageProps = {
      imageKey: key,
      storageLocationType,
      documentKey,
      isFullGalleryItem,
      isProfile,
      fullPath: path,
      customMetadata,
      imageOwner,
      ...item,
      item
    }
    return <div
      key={uniqueKey('ig', 'gc', key)}
      className={cn + ' ' + key}
    >
      {thumbnailDivImage(src, key, approved, customMetadata, imageProps)}
    </div>
  }

  const md = (customMetadata) => {
    const mds = []
    Object.keys(customMetadata).forEach(k => {
      switch (k) {
        case 'name':
          mds.push(<div key={uniqueKey('ig', 'md', k)} className={'image-meta'}>{customMetadata[k]}</div>)
          break;
        default:
        //nothing
      }
    })
    return mds
  }

  const pdfColumns = (src, key, cn, customMetadata) => <React.Fragment>
    {pdfColumn(src, key, cn, customMetadata)}
    {metadataColumn(key, cn, customMetadata)}
  </React.Fragment>

  const pdfColumn = (src, key, cn) => <div key={uniqueKey('ig', 'gc', key)} className={cn + ' ' + key} width={4}>
    <SemPdfSimple fileUrl={src} inGrid={true} handlePdfIconClick={handlePdfIconClick} />
  </div>

  const metadataColumn = (key, cn, customMetadata) => <div key={uniqueKey('ig', 'gcm', key)} className={cn + ' ' + key} width={12}>
    {customMetadata && md(customMetadata)}
  </div>

  const gridColumn = (src, key, cn, icn, approved, path, customMetadata, item) => {
    if (isPdf && 1 === 3) {
      return pdfColumns(src, key, cn, customMetadata, item)
    } else {
      return imageColumn(src, key, cn, icn, approved, path, customMetadata, item)
    }
  }

  const galleryImageColumns = (imgs) => {

    _.forEach(currentGallery, (item, key) => {

      const { urls, approved, path, customMetadata } = item ?? {}

      const { full, thumbnail } = urls ?? {}

      let icn;
      if (showApprovalWizard) {
        icn = {
          name: approved ? 'check square outline' : 'square outline',
          color: approved ? iconColorTypes.menuItem : iconColorTypes.default,
        }
      } else {
        icn = {
          name: (selectedImages && selectedImages[key]) ? 'check square outline' : 'square outline',
          color: (selectedImages && selectedImages[key]) ? iconColorTypes.menuItem : iconColorTypes.default,
        }
      }

      let cn = 'img-ts-col'
      if (isPdf) { cn += ' pdf' }

      if (approvedOnly && !showApprovalWizard) {
        if (approved) {
          if (thumbnail) {
            imgs.push(gridColumn(thumbnail, key, cn, icn, approved, path, customMetadata, item))
          } else if (full) {
            imgs.push(gridColumn(full, key, cn, icn, approved, path, customMetadata, item))
          }
        }
      } else {
        if (thumbnail) {
          imgs.push(gridColumn(thumbnail, key, cn, icn, approved, path, customMetadata, item))
        } else if (full) {
          imgs.push(gridColumn(full, key, cn, icn, approved, path, customMetadata, item))
        }
      }
    })
  }

  const galleryImage = (imgs) => {
    const { urls, uid, approved, customMetadata } = galleryItem ?? {}
    const { full } = urls ?? {}
    if (approvedOnly) {
      if (approved) { imgs.push(gridColumn(full, uid, null, null, null, null, customMetadata)) }
    } else {
      imgs.push(gridColumn(full, uid, null, null, null, null, customMetadata))
    }
  }

  const pageGalleryGrid = () => {
    const imgs = []
    if (currentGallery) { galleryImageColumns(imgs) }
    if (galleryItem) { galleryImage(imgs) }
    return <div key={uniqueKey('ig', 'gr')} className={_cn} >{imgs} </div>
  }

  const pageGalleryGridWithDivider = () => <React.Fragment>
    <Divider key={uniqueKey('ss', 'h')} horizontal>{'Gallery'}</Divider>
    {pageGalleryGrid()}
  </React.Fragment>

  const content = () => {
    if (currentGallery || galleryItem) {
      return viewOnly ? pageGalleryGridWithDivider() : pageGalleryGrid()
    } else {
      return <div></div>
    }
  }

  return content()
}

export default ImagesGrid